import {
    buildActionCreators,
    makeActionTypes,
    namedParameters,
} from '../../../common/helpers/ReduxHelpers';

import { DOMAIN } from './Configuration.constants';

export const events = {
    fieldChange: namedParameters('field', 'value', 'oldValue'),
};

export const types = makeActionTypes(Object.keys(events), DOMAIN);

export default buildActionCreators(events, types);
